import { SummerExtrasLeaderboardPageLoadEvent } from '@/services/analytics/events';
import { AdobeBaseEvent } from './adobe-base-event';
import { AnalyticsEventType } from '../models';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';

export class AdobeSummerExtrasPageLoadEvent extends AdobeBaseEvent {
    name = 'AdobeSummerExtrasPageLoadEvent';
    event = AnalyticsEventType.PageLoaded;

    constructor(
        event: SummerExtrasLeaderboardPageLoadEvent,
        store: Store<AppState>,
        services: ServicesContainer
    ) {
        super(store, services);

        const percent = store.state.leaderboard.statistics?.nationalRankPercentage;

        let ranking = '(not-set)';
        if (typeof percent === 'number') {
            ranking = percent > 0 && percent <= 30 ? 'National' : 'None';
        }

        this.account.ranking = ranking;
        
        this.web.webPageDetails = {
            language: 'en-us',
            name: 'rewards:extras:summer-of-extras',
            pageType: 'rewards',
            pageViews: { value: 1 },
            siteRegion: 'US',
            siteSection: 'rewards'
        };
    }
}
